import { Button, Form, Input, message } from "antd";
import uppassword_icon from "@/images/service/uppassword_icon.png";
import { Encrypt } from "@/utils/crypto";
import "./index.less";
import { serviceApi } from "@/apis";
import { useUserInfoDispath } from "@/model";

const validcheck = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,16}$/;

type FieldType = {
  originalPassword?: string;
  newPassword?: string;
  confirmPassword?: string;
};

const Uppassword = () => {
  const dispatch = useUserInfoDispath();

  const onFinish = (values: FieldType) => {
    serviceApi
      .updatePasswordInLoginStatus({
        originalPassword: Encrypt(values.originalPassword || ""),
        newPassword: Encrypt(values.newPassword || ""),
        confirmPassword: Encrypt(values.confirmPassword || ""),
      })
      .then(() => {
        message.success("更改密码成功，即将退出登录");
        setTimeout(() => {
          dispatch({
            type: "login/quit",
          });
          dispatch({
            type: "login/open",
          });
        }, 2000);
      })
      .catch((err) => {
        message.error(err);
      });
  };

  // const onFinishFailed = (errorInfo: any) => {
  //   console.log("Failed:", errorInfo);
  // };

  return (
    <div className="uppassword-wrapper">
      <div className="center-main-title">
        <img src={uppassword_icon} alt="" />
        <h3>修改密码</h3>
      </div>
      <div className="uppassword-content-wrapper">
        <Form
          name="basic"
          labelCol={{ span: 6 }}
          // wrapperCol={{ span: 16 }}
          style={{ maxWidth: 400 }}
          onFinish={onFinish}
          // onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item<FieldType>
            label="当前密码"
            name="originalPassword"
            className="uppassword-form-item"
            rules={[{ required: true, message: "当前密码不能为空!" }]}
          >
            <Input.Password />
          </Form.Item>

          <Form.Item<FieldType>
            label="更改密码"
            name="newPassword"
            className="uppassword-form-item"
            rules={[
              { required: true, message: "请输入密码!" },
              {
                pattern: validcheck,
                message: "密码必须包含大小写字母、数字、特殊字符，长度8-16位",
              },
            ]}
          >
            <Input.Password />
          </Form.Item>

          <Form.Item
            name="confirmPassword"
            label="确认密码"
            className="uppassword-form-item"
            dependencies={["newPassword"]}
            hasFeedback
            rules={[
              {
                required: true,
                message: "请再次输入密码!",
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("newPassword") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("两次输入密码不一致!"));
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>

          <Form.Item
            className="uppassword-form-btn"
            wrapperCol={{ offset: 6, span: 16 }}
            style={{ marginTop: 30 }}
          >
            <Button type="primary" htmlType="submit">
              确认修改
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default Uppassword;
